module.exports = __webpack_public_path__ + "media/images/emblems/Villeret-coat_of_arms-2f08bb1c51e343b582cb45c9abe8905d.svg";